import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import { deacService } from '../../services/central-api/deac';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { StyleProp, TextStyle } from 'react-native';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    setUnit?: React.Dispatch<React.SetStateAction<number>>;
    setCommand?: React.Dispatch<React.SetStateAction<number>>;
    setAddress?: React.Dispatch<React.SetStateAction<string>>;
    actingBodyId: number;
    actingBodyUnitId?: number;
    actingBodyCommandId?: number;
    zIndex: number;
    required?: boolean;
    disable?: boolean;
    labelFontSize?: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    allowAllActingBodies?: boolean;
}

export default function WorkplacesDropdown({ value, setValue, setUnit, setCommand, setAddress, zIndex, actingBodyId, actingBodyUnitId, actingBodyCommandId, disable, required, labelFontSize, labelStyle, viewStyle, allowAllActingBodies }: Props) {
    const [selectableWorkplaces, setSelectableWorkplaces] = useState<{ label: string; value: number; }[]>([]);
    const [workplaces, setWorkplaces] = useState<SimplifiedWorkplace[]>([]);

    async function loadWorkplaces(actingBodyId: number, actingBodyUnitId?: number, actingBodyCommandId?: number) {
        try {
            const workplaces = await deacService.getWorkplacesSimplified({ actingBodyId, actingBodyUnitId, actingBodyCommandId });
            setSelectableWorkplaces(workplaces.map((workplace) => {
                return {
                    value: workplace.id,
                    label: workplace.name,
                };
            }));
            setWorkplaces(workplaces);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (value && value > 0) {
            const workplace = workplaces.filter(w => w.id == value)[0];

            if (workplace) {
                setUnit?.(workplace.actingBodyUnit.id);
                setCommand?.(workplace.actingBodyCommand.id);
                setAddress?.(workplace.address);
            }
        }
    }, [value]);

    useEffect(() => {
        if (actingBodyId != 0 || allowAllActingBodies) {
            loadWorkplaces(actingBodyId, actingBodyUnitId, actingBodyCommandId);
        } else {
            setSelectableWorkplaces([]);
        }
    }, [actingBodyId, actingBodyUnitId, actingBodyCommandId]);

    return (
        <FilterDropdown
            label={translate('workplaces')}
            items={selectableWorkplaces}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            required={required}
            disabled={disable}
            labelFontSize={labelFontSize}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
